// extracted by mini-css-extract-plugin
export default {"wrapper":"B3-z","play":"C3-z"};